import * as React from "react";
import { Link } from "react-router";
import styled, { css } from "styled-components";
import { LinkStyles } from "./Link";
import { ControlArrowEnd } from "./icons/Arrows";

interface IBoldLinkStyleProps {
  color?: "blueDark" | undefined;
}

interface IBoldLinkStyles {
  color?: "blueDark";
}

const BoldLinkStyles = css<IBoldLinkStyles>`
  ${LinkStyles}

  display: inline-flex;
  align-items: center;
  font-size: ${({ theme }) => theme.fontSizes[1]};
`;

const StyledBoldLink = styled(Link)<IBoldLinkStyleProps>`
  ${BoldLinkStyles}
`;

interface IBoldLinkProps {
  children: React.ReactNode;
  color?: "blueDark";
  to: string;
}

const BoldLink: React.FC<IBoldLinkProps> = ({ children, to }) => (
  <StyledBoldLink to={to}>
    {children}
    <ControlArrowEnd color="blueDark" />
  </StyledBoldLink>
);

export default BoldLink;
